"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioDevicesMgrService = void 0;
class AudioDevicesMgrService {
    constructor($rootScope, $window, mediaDevices, processVolume, $log, webRtcAudio, $translate) {
        this.$rootScope = $rootScope;
        this.$window = $window;
        this.mediaDevices = mediaDevices;
        this.processVolume = processVolume;
        this.$log = $log;
        this.webRtcAudio = webRtcAudio;
        this.$translate = $translate;
        this.audioDevices = [];
        this.microphoneDevices = [];
        this.ringingDevices = [];
        this.AUDIO_DEVICE_UPDATE_EVT = "AudioDevicesUpdateEvent";
        this.MIC_DEVICE_UPDATE_EVT = "MicrophoneDevicesUpdateEvent";
        this.RINGING_DEVICE_UPDATE_EVT = "RingingDevicesUpdateEvent";
        this.AUDIO_DEVICE_PICKED_EVT = "AudioDevicePickedEvent";
        this.MIC_DEVICE_PICKED_EVT = "MicrophoneDevicePickedEvent";
        this.RINGING_DEVICE_PICKED_EVT = "RingingDevicePickedEvent";
        this.filterAndBroadcast = (devices, kind, eventName) => {
            const filtered = this.filterDevicesByKind(devices, kind);
            this.$rootScope.$broadcast(eventName, filtered);
            return filtered;
        };
    }
    changeAudioOutputDevice(deviceId) {
        this.$window.xc_webrtc.applyAudioOutputToElements(deviceId);
        this.$window.localStorage.setItem("AudioOutputDeviceId", deviceId);
        this.webRtcAudio.changeRingingDevice(deviceId, true);
    }
    changeAudioInputDevice(deviceId) {
        this.$window.SIPml.setGlobalMicrophoneDeviceId(deviceId);
        this.$window.xc_webrtc
            .swapCurrentMicrophone(deviceId)
            .then((newStream) => {
            this.processVolume.onMicChange(newStream);
        })
            .catch((err) => {
            this.$log.debug(err);
        });
        this.$window.localStorage.setItem("AudioInputDeviceId", deviceId);
    }
    changeRingingDevice(deviceId) {
        this.$window.localStorage.setItem("SecondaryRingingDeviceId", deviceId);
        this.webRtcAudio.changeRingingDevice(deviceId);
    }
    initAudioDevices() {
        this.mediaDevices
            .getAudioDevices()
            .then(this.initPreviousAudioDevices.bind(this))
            .catch((err) => {
            this.$log.error("Error when getting devices", err);
        });
    }
    initPreviousAudioDevices(devices) {
        this.sortDevices(devices);
        this.initOutputs();
        this.initInputs();
        this.initRinging();
    }
    sortDevices(devices) {
        const noneDevice = {
            deviceId: "null",
            kind: "audiooutput",
            label: this.$translate.instant("SECONDARY_RINGING_NO_DEVICE_LABEL"),
        };
        this.audioDevices = this.filterAndBroadcast(devices, "audiooutput", this.AUDIO_DEVICE_UPDATE_EVT);
        this.ringingDevices = this.filterAndBroadcast([...devices, noneDevice].filter((device) => device.deviceId !== "default"), "audiooutput", this.RINGING_DEVICE_UPDATE_EVT);
        this.microphoneDevices = this.filterAndBroadcast(devices, "audioinput", this.MIC_DEVICE_UPDATE_EVT);
    }
    initRinging() {
        let selectedRingingDevice = this.selectDevice(this.ringingDevices, "SecondaryRingingDeviceId", "null");
        this.$rootScope.$broadcast(this.RINGING_DEVICE_PICKED_EVT, selectedRingingDevice);
    }
    initOutputs() {
        let selectedAudioDevice = this.selectDevice(this.audioDevices, "AudioOutputDeviceId");
        this.$rootScope.$broadcast(this.AUDIO_DEVICE_PICKED_EVT, selectedAudioDevice);
    }
    initInputs() {
        let selectedMicrophoneDevice = this.selectDevice(this.microphoneDevices, "AudioInputDeviceId");
        this.$rootScope.$broadcast(this.MIC_DEVICE_PICKED_EVT, selectedMicrophoneDevice);
    }
    selectDevice(devices, storageKey, defaultValue = "default") {
        const storedId = this.$window.localStorage.getItem(storageKey);
        return (devices.find((device) => device.deviceId == storedId) ||
            devices.find((device) => device.deviceId == defaultValue));
    }
    filterDevicesByKind(devices, kind) {
        return devices.filter((device) => device.kind === kind);
    }
}
exports.AudioDevicesMgrService = AudioDevicesMgrService;
AudioDevicesMgrService.$inject = [
    "$rootScope",
    "$window",
    "mediaDevices",
    "processVolume",
    "$log",
    "webRtcAudio",
    "$translate",
];
